import BDiaryDayForm from "./BDiaryDayForm";

export default class BDiaryDayFormGlucose extends BDiaryDayForm
{
	static selector = () => `.profile-diary-day-form--glucose`;

	static initialize()
	{
		document.addEventListener("change", event => {
			if (event.target.matches(`${this.selector()} [name="mealContext"]`)) {
				event.target.closest(`dialog`).querySelector(`.profile-diary-day-form__meal-offset-options`).hidden = (event.target.value != "afterMeal");
			}
		});

		document.addEventListener("change", event => {
			if (event.target.matches(`${this.selector()} [name="mealOffsetPreset"]`)) {
				if (event.target.value == "custom") {
					event.target.closest(`dialog`).querySelector(`.profile-diary-day-form__meal-offset`).hidden = false;
					event.target.closest(`dialog`).querySelector(`.profile-diary-day-form__meal-offset input`).focus();
				} else {
					event.target.closest(`dialog`).querySelector(`.profile-diary-day-form__meal-offset`).hidden = true;
				}
			}
		});
	}
}
